const hostname = window?.location?.hostname || '';
let config;
if (hostname.includes('localhost') || hostname.includes('127.0.0.1')) {
  console.log('🔧 Running in Localhost Mode');
  config = {
    API_URL: 'http://localhost:5005',
    STORAGE_URL: 'http://127.0.0.1/arkan/',
    API_STREAM_URL: 'http://127.0.0.1:5006',
    FINGERPRINT_API:"https://localhost:5001/api/fingerprint",
  };
} else if (hostname.includes('alarkkan.app')) {
  console.log('🚀 Running in Production Mode');
  config = {
    API_URL: 'https://alarkkan.app/api',
    STORAGE_URL: 'https://s3.alarkkan.app/arkan/',
    API_STREAM_URL: 'https://alarkkan.app/stream/',
    FINGERPRINT_API:"https://old.alarkkan.app/api/fingerprint",
  };
} else {
  console.log('🧪 Running in UAT/Staging Mode');
  config = {
    API_URL: 'https://uat.alarkkan.app/api',
    STORAGE_URL: 'https://uat-storage.alarkkan.app/arkan/',
    API_STREAM_URL: 'https://uat-stream.alarkkan.app/',
        FINGERPRINT_API:"https://old.alarkkan.app/api/fingerprint",

  };
}
export default config;